import { Database } from "@phosphor-icons/react";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between brand-ink text-white p-12 relative overflow-hidden border-r border-white/5">
        <div className="absolute inset-0 brand-grid pointer-events-none" />
        <div className="flex items-center gap-2.5 relative z-10">
          <span className="w-9 h-9 rounded-xl bg-[#C2410C] flex items-center justify-center shadow-glow">
            <Database size={20} weight="fill" className="text-white" />
          </span>
          <span className="font-head font-bold text-xl">Inspiro Interface</span>
        </div>
        <div className="relative z-10">
          <h2 className="font-head font-black text-4xl leading-tight tracking-tight">
            Enterprise data<br />migration, without<br />the point-to-point mess.
          </h2>
          <p className="text-zinc-300 mt-6 max-w-md text-sm leading-relaxed">
            A connector-based platform to discover, map, transform, validate and migrate
            records between Salesforce, HubSpot, CSV and beyond — with full tenant isolation
            and audit trails.
          </p>
        </div>
        <div className="relative z-10 text-xs text-zinc-500">© 2026 Inspiro Interface</div>
      </div>

      {/* Right content */}
      <div className="flex items-center justify-center p-8 bg-[#FAFAFA]">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <Database size={24} weight="fill" />
            <span className="font-head font-bold text-lg">Inspiro Interface</span>
          </div>
          <h1 className="font-head font-bold text-2xl tracking-tight text-stone-950">{title}</h1>
          {subtitle && <p className="text-sm text-stone-500 mt-1 mb-8">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
